import { Box, Card, CardContent, Stack, Table, TableBody, TableCell, TableRow, Typography, TextField } from '@mui/material';
import React, { useState, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import TextBox from './base_components/TextBox.tsx';
import SubmitButton from './base_components/SubmitButton.tsx';
import TeamSelectBox from './common_components/TeamSelectBox.tsx';
import { useSearchParams } from 'react-router-dom';
import { getParamCaseInsensitive } from '../helpers/SearchParamsHelper.ts';

const LoginPage = ({ onLoginClickCallback, headerText }) => {
    const [searchParams] = useSearchParams();
    const [loading, setLoading] = useState(false);
    const [isFacilitator, setIsFacilitator] = useState(false);
    console.log("🚀 ~ LoginPage ~ isFacilitator:", isFacilitator)
    const [email, setEmail] = useState('');
    
    console.log("🚀 ~ LoginPage ~ loading:", loading);
    
    const gaminarCode = getParamCaseInsensitive(searchParams, "sessioncode");
    
    // Get email from search params
    const paramEmail = getParamCaseInsensitive(searchParams, "email");

    const { control, handleSubmit, formState: { errors } } = useForm({
        defaultValues: {}
    });

    const onSubmit = async (data) => {
        setLoading(true);
        try {
            const payload = data;
            payload.email = email;
            payload.isFacilitator = isFacilitator;
            payload.facilatatorEmail = paramEmail;
            onLoginClickCallback(payload);
        } catch (error) {
            console.log(error);
            alert(error.response.data);
        }
        setLoading(false);
    };

    // useEffect to check email change
    useEffect(() => {
        if (email.toLowerCase() === paramEmail?.toLowerCase()) {
            setIsFacilitator(true); // Set facilitator state true if email matches
        } else {
            setIsFacilitator(false); // Otherwise, set it to false
        }
    }, [email, paramEmail]);

    // Handle change for email input
    const handleEmailChange = (event) => {
        setEmail(event.target.value);
    };

    return (
        <Box display="flex" justifyContent="center" alignItems="center" height="100vh"
            sx={{
                backgroundImage: 'url("/img/login-background.jpg")',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
            }}>
            <Table sx={{ height: "65%", width: "auto", mt: 14 }}>
                <TableBody>
                    <TableRow sx={{
                        display: "inline-flex",
                        flexDirection: "row",
                        flexWrap: "wrap",
                        alignContent: "center",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "100%",
                        width: "100%",
                    }}>
                        <TableCell align="center" sx={{
                            backgroundColor: "#f5f6fa",
                            width: "auto",
                            height: "100%",
                            alignContent: "center",
                        }}>
                            <img src="/login-image.png" style={{ maxWidth: '100%', maxHeight: '100%' }} alt='img' />
                        </TableCell>
                        <TableCell sx={{
                            backgroundColor: "#fff",
                            width: "auto",
                            height: "100%",
                            alignContent: "right",
                        }}>
                            <form onSubmit={handleSubmit(onSubmit)} style={{ height: "100%" }}>
                                <Card sx={{ width: '350px', height: "100%", padding: 0 }} variant='elevation'>
                                    <CardContent>
                                        <Box>
                                            <Stack direction="column" sx={{ justifyContent: 'space-between', alignItems: 'left' }}>
                                                <Typography gutterBottom variant="h6" component="div">
                                                    {headerText}
                                                </Typography>
                                                <Typography gutterBottom variant="body2" component="div">
                                                    Welcome back to Council of Marble Stars
                                                </Typography>
                                            </Stack>
                                            <br />
                                        </Box>
                                        <Box>
                                            <Stack direction="column" spacing={1}>
                                                <TextBox
                                                    name="name"
                                                    id="txtName"
                                                    control={control}
                                                    errors={errors}
                                                    label="Name"
                                                />

                                                {/* Email field handled separately */}
                                                <TextField
                                                    id="txtEmail"
                                                    label="Email"
                                                    type="email"
                                                    value={email}
                                                    onChange={handleEmailChange}
                                                    // error={!!errors.email}
                                                    // helperText={errors.email ? "Invalid email" : ""}
                                                    required
                                                    fullWidth
                                                />

                                                {isFacilitator ? null : (
                                                    <TeamSelectBox control={control} errors={errors} />
                                                )}

                                                <TextBox
                                                    name="gaminarCode"
                                                    id="txtGaminarCode"
                                                    control={control}
                                                    errors={errors}
                                                    disabled
                                                    defaultValue={gaminarCode}
                                                    label="Session Code"
                                                />
                                                <br />
                                                <SubmitButton
                                                    id="btnSubmit"
                                                    loading={loading}
                                                    loadingText="Submitting"
                                                    text="Login"
                                                />
                                            </Stack>
                                        </Box>
                                    </CardContent>
                                </Card>
                            </form>
                        </TableCell>
                    </TableRow>
                </TableBody>
            </Table>
        </Box>
    );
};

export default LoginPage;
